<template>
  <div class="login-frame">

    <div class="login-name login-input">
      <input type="text" name="mobile" v-model="login.mobile" autocomplete="off"/>
      <span class="placeholder" :class="{fixed: login.mobile !== '' && login.mobile != null}">手机号</span>
    </div>
    <div class="login-password login-input">
      <input type="password" name="password" v-model="login.password" @keyup.enter="submit" autocomplete="off"/>
      <span class="placeholder" :class="{fixed: login.password !== '' && login.password != null}">密码</span>
      <span @click="$emit('input','ForgotPassword')" class="placeholder forgot-password text-hover" :class="{fixed: login.password !== '' && login.password != null}">忘记密码</span>
    </div>
    <div class="remember-row">
      <label class="remember-me">
        <input type="checkbox" v-model="rememberMe" />
        <span>记住手机号</span>
      </label>
    </div>
    <div class="buttonDiv">
      <Button :loading="loading" block color="primary" size="l" @click="submit">登录</Button>
    </div>
    <!-- 注册功能已隐藏 -->
    <!-- <div class="margin" style="margin-bottom: 0 !important;">
      <span class="text-hover" @click="$emit('input','Registered')">立即注册</span>
    </div> -->
  </div>
</template>
<script>
const REMEMBERED_MOBILE_KEY = 'financial_remembered_mobile';

export default {
  name: 'LoginForm',
  data() {
    return {
      login: {
        mobile: "",
        password: "",
      },
      loading: false,
      rememberMe: false
    }
  },
  mounted() {
    // 读取记住的手机号
    const savedMobile = localStorage.getItem(REMEMBERED_MOBILE_KEY);
    if (savedMobile) {
      this.login.mobile = savedMobile;
      this.rememberMe = true;
    }
  },
  methods: {
    submit() {
      if (this.login.mobile && this.login.password) {
        this.loading = true
        this.$api.common.login(this.login).then(() => {
          // 保存或清除记住的手机号
          if (this.rememberMe) {
            localStorage.setItem(REMEMBERED_MOBILE_KEY, this.login.mobile);
          } else {
            localStorage.removeItem(REMEMBERED_MOBILE_KEY);
          }
          window.location.replace('/');
        }).catch(() => {
          this.loading = false
        });
      }
    }
  }
}
</script>
<style scoped>
.remember-row {
  display: flex;
  justify-content: flex-start;
  margin-top: -15px;
  margin-bottom: 15px;
}
.remember-me {
  display: flex;
  align-items: center;
  font-size: 13px;
  color: #7e7e7e;
  cursor: pointer;
  user-select: none;
}
.remember-me input {
  margin-right: 5px;
  cursor: pointer;
}
.remember-me:hover {
  color: #3788ee;
}
</style>
